import { ExamCenterProctorRequestType } from '@exam-center/graphql';
import { zodResolver, type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  DraftProctorRequestEditionFormSchema,
  type DraftProctorRequestEditionFormInput,
} from './schemas';

type DraftProctorRequestEditionFormProviderProps = PropsWithChildren;

export default function DraftProctorRequestEditionFormProvider(
  props: Readonly<DraftProctorRequestEditionFormProviderProps>,
) {
  const { children } = props;

  const formContext = useForm<DraftProctorRequestEditionFormInput>({
    resolver: zodResolver(DraftProctorRequestEditionFormSchema),
    defaultValues: {
      proctorType: ExamCenterProctorRequestType.Proctor_1,
      personal: {
        idNumber: '',
        titleTh: null,
        firstNameTh: '',
        lastNameTh: '',
        titleEn: null,
        firstNameEn: '',
        lastNameEn: '',
        email: '',
        phoneNumber: '',
        address: '',
      },
      employeeInfo: {
        code: '',
        position: '',
        department: '',
        termination: { isAssigned: 'false', endedAt: null },
      },
      document: {
        agreementForms: [],
        identifications: [],
      },
    } as unknown as DraftProctorRequestEditionFormInput,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
